export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "emptyPets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You have not placed any pets yet!"])},
        "pets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Pets"])},
        "petCreate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create new pet"])}
      },
      "de": {
        "emptyPets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sie haben noch keine Haustiere angegeben!"])},
        "pets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meine Haustiere"])},
        "petCreate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Haustier erstellen"])}
      }
    }
  })
}